const supportedLanguages = {
  en: "English",
  gb: "English",
  sk: "Slovensky",
  cs: "Česky",
  cz: "Česky",
  hu: "Magyar",
  de: "Deutsch",
  sv: "Svenska",
  se: "Svenska"
  // xx: 'Crowdin',
};
const getLanguageName = (code) => supportedLanguages[code.toLowerCase()] || code;
function localeToFlagCode(code) {
  const useSecondPartLocales = [
    "cs-CZ",
    "sv-SE"
  ];
  const partIndex = useSecondPartLocales.includes(code) ? 1 : 0;
  let flagCode = code.split("-")[partIndex] || "";
  if (flagCode.toLowerCase() === "en") {
    flagCode = "gb";
  }
  return flagCode;
}
export {
  getLanguageName,
  localeToFlagCode,
  supportedLanguages
};
//# sourceMappingURL=utils.es.js.map
